import { Component, OnInit, OnDestroy } from '@angular/core';
import { formatDate } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { MatSnackBar } from '@angular/material';
import { Subscription, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { DataService } from '../data';

import * as ApiModels from 'src/api';
import { Router } from '@angular/router';

interface UserInfo extends ApiModels.UserInfo {
  balanceDisplay?: string;
  nextDayCount?: number;
  lastDate?: string;
  canPay?: boolean;
}

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
})
export class HomeComponent implements OnInit, OnDestroy {
  subscription: Subscription;
  userInfo: UserInfo;

  constructor(
    private http: HttpClient,
    private dataService: DataService,
    private readonly snackBar: MatSnackBar,
    private readonly router: Router,
  ) {
    this.subscription = this.dataService.onGetData.subscribe(response => {
      this.userInfo = response;
      this.userInfo = this.normalizeUserInfo(this.userInfo);
    });
  }

  ngOnInit() {
    if (!this.userInfo) {
      this.userInfo = this.dataService.userInfo;
      this.dataService.getData();
    }

    const queryParams = window.location.search;
    if (queryParams) {
      this.http
        .get(`/api/bank/processResponse${queryParams}`)
        .pipe(
          catchError(error => {
            this.snackBar.open(error.error, 'Ошибка', {
              duration: 5000,
            });

            this.router.navigate([]);

            return throwError(() => error);
          }),
        )
        .subscribe(() => {
          window.location.assign('');
        });
    }
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  private normalizeUserInfo(userInfo: UserInfo) {
    userInfo.balanceDisplay = (userInfo.balance > 0 ? '+ ' : '') + userInfo.balance;
    userInfo.lastDate = userInfo.lasT_VALUE_DATE ? formatDate(userInfo.lasT_VALUE_DATE, 'dd.MM.yyyy', 'ru') : '—';
    userInfo.nextDayCount = userInfo.begin_Counters;

    return userInfo;
  }
}
